import { trigger, transition, style, animate } from '@angular/animations';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ADMIN_NAVIGATIONS } from 'src/app/shared/constants';
import { AdminSupportService } from 'src/app/services/admin-support/admin-support.service';
import { SidebarItem } from 'src/app/types/general';

@Component({
  selector: 'app-sidemenu-nav',
  templateUrl: 'sidemenu-nav.component.html',
  standalone: true,
  imports: [RouterLink, NgClass, NgTemplateOutlet, MatIconModule],
  animations: [
    trigger('submenuTransition', [
      transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('0.3s ease-in-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [animate('0.3s ease-in-out', style({ height: '0px', opacity: 0 }))]),
    ]),
  ],
})
export class SidemenuNavComponent implements OnInit {
  private readonly adminSupportService = inject(AdminSupportService);

  @Input() selectedMenuItem: number | null = null;
  @Input() selectedSubmenuItem: number | null = null;
  @Output() subMenuItemSelect = new EventEmitter<number | null>();
  @Output() menuItemSelect = new EventEmitter<number | null>();

  readonly items = ADMIN_NAVIGATIONS;

  ngOnInit() {
    this.adminSupportService.refreshFollowUpCount();
  }

  /** The entry's count; nothing shows at `0`. */
  badgeCount(item: SidebarItem) {
    return item.badge === 'support-follow-up' ? this.adminSupportService.followUpCount() : 0;
  }

  onSelectMenuItem(index: number) {
    if (this.selectedMenuItem !== index) this.subMenuItemSelect.emit(null);

    this.menuItemSelect.emit(index);
  }
}
